export const LogoMark = ({ className = "h-7 w-auto" }) => (
  <img src="/brand/lp-mark.png" alt="Logo Lucas Pasquinetti" className={className} data-testid="logo-mark" />
);

export const Logo = ({ onClick }) => (
  <button onClick={onClick} className="group flex items-center gap-3" data-testid="nav-logo">
    <LogoMark className="h-8 w-auto transition-transform duration-500 group-hover:-skew-x-6 group-hover:scale-105" />
    <span className="hidden font-mono text-[11px] font-medium uppercase tracking-[0.35em] text-white sm:inline">
      Lucas Pasquinetti
    </span>
  </button>
);
